import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color } = theme;

const titleWrap: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  minWidth: 0,
};

const title: CSSObject = {
  minWidth: 0,
  fontSize: 15,
  fontWeight: 600,
  color: color.text,
  wordBreak: 'break-all',
};

const meta: CSSObject = {
  fontSize: 13,
  color: color.textSub,
  wordBreak: 'keep-all',
  overflowWrap: 'anywhere',
};

export { titleWrap, title, meta };
